export { default } from './index.vue'



// WEBPACK FOOTER //
// ./packages/dof-numcard-col/index.js